import React, { useEffect, useState } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Card18 = ({ title }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    fetch(`${API}/recalage_cmde_frn`)
      .then(res => res.json())
      .then(data => setValue(data.length))
      .catch(err => { console.error('Erreur récupération commandes à recaler:', err); setValue(0); });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '120px', width: '220px', backgroundColor: '#ffffff', border: '1px solid #f0ece2', borderRadius: '14px', padding: '16px 20px', boxSizing: 'border-box', position: 'relative', overflow: 'hidden', cursor: 'pointer' }}>

      {/* Barre accent — ORANGE */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #92400e, #f59e0b)', borderRadius: '14px 14px 0 0' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{ width: '28px', height: '28px', backgroundColor: '#fef3c7', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="17 1 21 5 17 9"/>
            <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
            <polyline points="7 23 3 19 7 15"/>
            <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
          </svg>
        </div>
        <span style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '15px', fontWeight: '500', color: '#8b7b64', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Cmdes à recaler
        </span>
      </div>

      <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '32px', fontWeight: '600', color: '#0f172a', lineHeight: 1, textAlign: 'center' }}>
        {value === null ? <span style={{ fontSize: '20px', color: '#cbd5e1' }}>—</span> : value}
      </div>
    </div>
  );
};

export default Card18;